module.exports = __webpack_public_path__ + "img/arcade-v3-blurred.f37f76b4.jpg";